import { TableCell } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReportTable from "../../components/ReportTable";
import { ReportHeader } from "../../external/ensolvers-core-frontend-mui/dto/ReportDTO";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { TimeoffRequestersAndHours } from "../../models/TimeoffRequestersAndHours";
import TimeoffService from "../../services/TimeoffService";
import { AppToolbar } from "../AppToolbar";

export default function TimeOffExternalSummary() {
  const { t } = useTranslation();

  const [headers, setHeaders] = useState<ReportHeader[]>();
  const [rows, setRows] = useState<TimeoffRequestersAndHours[]>([]);

  useEffect(() => {
    loadHeaders();
    getTimeOffExternalSummary();
  }, []);

  const loadHeaders = () => {
    let headers = new Array<ReportHeader>();
    headers.push({ label: "Requester", align: "left" });
    headers.push({ label: "Hours", align: "left" });
    setHeaders(headers);
  };

  const getTimeOffExternalSummary = () => {
    TimeoffService.getTimeOffExternalSummary()
      .then((response) => {
        setRows(response.getContent());
      })
      .catch((err) => NotificationService.error(err));
  };

  return (
    <>
      <AppToolbar title={t("Time Off Requester - Hours")} />
      <ReportTable<TimeoffRequestersAndHours>
        headers={headers!}
        rows={rows}
        denseTable
        tableRow={(instance) => (
          <>
            <TableCell>{instance.requester}</TableCell>
            <TableCell>{instance.hours}</TableCell>
          </>
        )}
      />
    </>
  );
}
